function resolve(root, path) {
  if (!root || !path) return undefined;
  let cur = root;
  for (const p of path.split('.')) {
    if (cur == null) return undefined;
    cur = cur[p];
  }
  return cur;
}

const strings = {
  en: {
    title: 'Company Profile',
    subtitle: 'Manage company details, defaults, messaging, and accounting settings.',
    tabs: {
      company: 'Company',
      defaults: 'Defaults',
      smsEmail: 'SMS & Email',
      account: 'Account',
      superUser: 'Super User',
    },
    actions: {
      save: 'Update profile',
      saving: 'Saving…',
      logoutAll: 'Remove all user login sessions',
      logoutAllHint: 'Signs out every user. You will need to log in again.',
      logoutAllConfirm: 'Remove all active login sessions for every user?',
      chooseLogo: 'Choose logo',
    },
    company: {
      name: 'Company name',
      mobile: 'Mobile no.',
      telephone: 'Telephone no.',
      email: 'Email',
      website: 'Website',
      address: 'Address',
      logo: 'Logo',
      logoHint: 'PNG or JPG, max 2 MB. Saved with the profile.',
    },
    defaults: {
      defDelCharge: 'Default delivery charge',
      defaultType: 'Default type',
      defTax: 'Default TAX (%)',
      defPayType: 'Default pay type',
      defChargeFrom: 'Default charge from',
      payCad: 'Cash after delivery',
      payCod: 'Cash on delivery',
      chargeClient: 'Client',
      chargeArea: 'Area',
      selectType: 'Select type',
    },
    flags: {
      isSameDay: 'Same day delivery',
      isVatFromDelivery: 'VAT from delivery',
      isBlockByOrderSelection: 'Block order selection in payment',
      isPickupByComp: 'Save order with pickup driver',
      isBlockCancelPay: 'Block cancel orders in client payment',
      isKeepEmirate: 'Keep emirate unchanged on order entry',
      isSmsFromDn: 'Manual delivery SMS',
      isSeperateClientPayment: 'Separate client payment',
      allowSameClientNo: 'Allow clients with same mobile',
      allowSameCustomerNo: 'Allow customers with same mobile',
      adjustCpDate: 'Adjust client payment date',
      blockPayRetn: 'Block return option in payment and return status',
      blockCustomerOrderLoad: 'Block customer order load',
      onlyDeliveredSms: 'Only delivered SMS',
      hideCodSelection: 'Hide COD selection',
      isBlockSameStoreVoucherNo: 'Block multi store voucher no.',
      isBlockStoreRefLoad: 'Manual store ref',
      isHideOrderDelete: 'Hide order delete',
      isAutoGenerateVoucherNo: 'Auto voucher no.',
      isHidePaymentEditOnShipment: 'Hide payment edit on shipment',
      isHideDeliveryEditOnShipment: 'Hide delivery edit on shipment',
      isHidePaymentEditOnOrder: 'Hide payment edit on order',
      isHideDeliveryEditOnOrder: 'Hide delivery edit on order',
      isMaskClientMobNo: 'Mask client mobile no.',
      isBlockExcelExport: 'Block Excel export',
      isBlockPdfReport: 'Block PDF print',
      isBlockIncomeInShipment: 'Hide income details in shipment',
    },
    sms: {
      smsUser: 'SMS username',
      smsPassword: 'SMS password',
      smsId: 'SMS ID',
      emailUser: 'Email user',
      emailPassword: 'Email password',
      fireApiKey: 'Firebase API key',
      fireAuthDomain: 'Auth domain',
      fireProjectId: 'Project ID',
      fireStorageBucket: 'Storage bucket',
      fireMessagingSenderId: 'Messaging sender ID',
      fireAppId: 'App ID',
      fireMeasurementId: 'Measurement ID',
      fireServerKey: 'Server key',
    },
    account: {
      financialYear: 'Default financial year',
      inputVat: 'Default input VAT account',
      outputVat: 'Default output VAT account',
      clientHead: 'Default client head account',
      employeeHead: 'Default employee head account',
      expenseHead: 'Default expense head account',
      customerAccount: 'Default customer account',
      deliveryRevenue: 'Default delivery revenue account',
      cashAccount: 'Default cash account',
      bankAccount: 'Default bank account',
      searchAccount: 'Search account by name…',
    },
    super: {
      isAccounting: 'Accounting module',
      isHr: 'HR module',
      isMap: 'Map tracking',
      isPushNotifications: 'Push notifications',
      isVatFromCustomerOnly: 'VAT from customer only',
      isOtp: 'Login OTP',
    },
    toast: {
      loadFailed: 'Failed to load company profile.',
      saveSuccess: 'Profile updated successfully.',
      saveFailed: 'Failed to update profile.',
      networkError: 'Network error. Please try again.',
      logoutSuccess: 'All sessions removed. Please sign in again.',
      logoutFailed: 'Failed to remove sessions.',
    },
  },
  ar: {
    title: 'ملف الشركة',
    subtitle: 'إدارة بيانات الشركة والإعدادات الافتراضية والرسائل والمحاسبة.',
    tabs: {
      company: 'الشركة',
      defaults: 'الافتراضيات',
      smsEmail: 'SMS والبريد',
      account: 'الحسابات',
      superUser: 'مستخدم فائق',
    },
    actions: {
      save: 'تحديث الملف',
      saving: 'جاري الحفظ…',
      logoutAll: 'إزالة جميع جلسات تسجيل الدخول',
      logoutAllHint: 'يسجّل خروج جميع المستخدمين. ستحتاج لتسجيل الدخول مجدداً.',
      logoutAllConfirm: 'إزالة جميع جلسات تسجيل الدخول لكل المستخدمين؟',
      chooseLogo: 'اختيار الشعار',
    },
    company: {
      name: 'اسم الشركة',
      mobile: 'رقم الجوال',
      telephone: 'رقم الهاتف',
      email: 'البريد الإلكتروني',
      website: 'الموقع',
      address: 'العنوان',
      logo: 'الشعار',
      logoHint: 'PNG أو JPG، بحد أقصى 2 ميجابايت.',
    },
    defaults: {
      defDelCharge: 'رسوم التوصيل الافتراضية',
      defaultType: 'النوع الافتراضي',
      defTax: 'الضريبة الافتراضية (%)',
      defPayType: 'نوع الدفع الافتراضي',
      defChargeFrom: 'تحميل الرسوم من',
      payCad: 'نقداً بعد التوصيل',
      payCod: 'الدفع عند الاستلام',
      chargeClient: 'العميل',
      chargeArea: 'المنطقة',
      selectType: 'اختر النوع',
    },
    flags: {
      isSameDay: 'توصيل في نفس اليوم',
      isVatFromDelivery: 'ضريبة من التوصيل',
      isBlockByOrderSelection: 'منع اختيار الطلب في الدفع',
      isPickupByComp: 'حفظ الطلب مع سائق الاستلام',
      isBlockCancelPay: 'منع إلغاء الطلبات في دفع العميل',
      isKeepEmirate: 'الإبقاء على الإمارة عند إدخال الطلب',
      isSmsFromDn: 'SMS توصيل يدوي',
      isSeperateClientPayment: 'دفع عميل منفصل',
      allowSameClientNo: 'السماح بنفس جوال العملاء',
      allowSameCustomerNo: 'السماح بنفس جوال المستلمين',
      adjustCpDate: 'تعديل تاريخ دفع العميل',
      blockPayRetn: 'منع الإرجاع في الدفع والحالة',
      blockCustomerOrderLoad: 'منع تحميل طلب العميل',
      onlyDeliveredSms: 'SMS للمُسلّم فقط',
      hideCodSelection: 'إخفاء خيار COD',
      isBlockSameStoreVoucherNo: 'منع تكرار قسيمة المتجر',
      isBlockStoreRefLoad: 'مرجع متجر يدوي',
      isHideOrderDelete: 'إخفاء حذف الطلب',
      isAutoGenerateVoucherNo: 'رقم قسيمة تلقائي',
      isHidePaymentEditOnShipment: 'إخفاء تعديل الدفع في الشحنة',
      isHideDeliveryEditOnShipment: 'إخفاء تعديل التوصيل في الشحنة',
      isHidePaymentEditOnOrder: 'إخفاء تعديل الدفع في الطلب',
      isHideDeliveryEditOnOrder: 'إخفاء تعديل التوصيل في الطلب',
      isMaskClientMobNo: 'إخفاء جوال العميل',
      isBlockExcelExport: 'منع تصدير Excel',
      isBlockPdfReport: 'منع طباعة PDF',
      isBlockIncomeInShipment: 'إخفاء الدخل في الشحنة',
    },
    sms: {
      smsUser: 'اسم مستخدم SMS',
      smsPassword: 'كلمة مرور SMS',
      smsId: 'معرّف SMS',
      emailUser: 'مستخدم البريد',
      emailPassword: 'كلمة مرور البريد',
      fireApiKey: 'مفتاح Firebase API',
      fireAuthDomain: 'نطاق المصادقة',
      fireProjectId: 'معرّف المشروع',
      fireStorageBucket: 'دلو التخزين',
      fireMessagingSenderId: 'معرّف مرسل الرسائل',
      fireAppId: 'معرّف التطبيق',
      fireMeasurementId: 'معرّف القياس',
      fireServerKey: 'مفتاح الخادم',
    },
    account: {
      financialYear: 'السنة المالية الافتراضية',
      inputVat: 'حساب ضريبة المدخلات',
      outputVat: 'حساب ضريبة المخرجات',
      clientHead: 'حساب رئيس العملاء',
      employeeHead: 'حساب رئيس الموظفين',
      expenseHead: 'حساب رئيس المصروفات',
      customerAccount: 'حساب العميل الافتراضي',
      deliveryRevenue: 'حساب إيراد التوصيل',
      cashAccount: 'حساب النقد',
      bankAccount: 'حساب البنك',
      searchAccount: 'بحث عن حساب بالاسم…',
    },
    super: {
      isAccounting: 'وحدة المحاسبة',
      isHr: 'وحدة الموارد البشرية',
      isMap: 'تتبع الخريطة',
      isPushNotifications: 'إشعارات الدفع',
      isVatFromCustomerOnly: 'ضريبة من العميل فقط',
      isOtp: 'OTP تسجيل الدخول',
    },
    toast: {
      loadFailed: 'تعذّر تحميل ملف الشركة.',
      saveSuccess: 'تم تحديث الملف بنجاح.',
      saveFailed: 'تعذّر تحديث الملف.',
      networkError: 'خطأ في الشبكة. حاول مرة أخرى.',
      logoutSuccess: 'تمت إزالة الجلسات. يرجى تسجيل الدخول.',
      logoutFailed: 'تعذّر إزالة الجلسات.',
    },
  },
};

export function getCompanyProfileT(lang) {
  const root = strings[lang] || strings.en;
  return (path, vars) => {
    let v = resolve(root, path);
    if (typeof v !== 'string') return path;
    if (vars && typeof vars === 'object') {
      Object.keys(vars).forEach((k) => {
        v = v.replace(new RegExp(`\\{${k}\\}`, 'g'), String(vars[k]));
      });
    }
    return v;
  };
}
